import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, control, fontSize, shadow } = theme.tokens;

  return {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      minWidth: 0
    },
    label: {
      fontSize: fontSize.ui,
      fontWeight: 600,
      color: color.ink
    },
    optional: {
      fontWeight: 400,
      color: color.muted
    },
    box: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      minHeight: control.md,
      padding: "0 16px",
      borderRadius: radius.field,
      backgroundColor: color.field,
      boxSizing: "border-box",
      transition: "box-shadow .15s, background-color .15s",
      "&:hover": { backgroundColor: color.fieldHover },
      "&:focus-within": {
        backgroundColor: color.field,
        boxShadow: shadow.selected
      }
    },
    multiline: {
      alignItems: "flex-start",
      padding: "12px 16px"
    },
    hasError: {
      backgroundColor: color.dangerTint,
      boxShadow: `inset 0 0 0 2px ${color.danger}`,
      "&:hover": { backgroundColor: color.dangerTint }
    },
    disabled: {
      opacity: 0.6,
      "&:hover": { backgroundColor: color.field }
    },
    prefix: {
      fontSize: fontSize.body,
      fontWeight: 600,
      color: color.ink,
      paddingRight: 10,
      boxShadow: `inset -1px 0 0 ${color.lineStrong}`
    },
    input: {
      flex: 1,
      minWidth: 0,
      border: 0,
      outline: 0,
      background: "none",
      padding: 0,
      margin: 0,
      font: "inherit",
      fontSize: fontSize.body,
      color: color.ink,
      resize: "vertical",
      "&::placeholder": { color: color.muted, opacity: 1 },
      // the box shows focus; keep a visible ring only for keyboard users
      "&:focus-visible": { outline: "none" }
    },
    help: {
      fontSize: fontSize.small,
      color: color.muted
    },
    errorText: {
      color: color.danger,
      fontWeight: 600
    }
  };
});

export default withCustomStyles;
